document.addEventListener('click', (e) => {
    let target = e.target;

    if ( target.classList.contains('accordion-title') ) {
        console.log('Accordion clicked', target );
        const selected_accordion = target.closest('.accordion-wrapper');
        console.log(selected_accordion)
        const accordion_parent = target.closest('.accordion-category');
        console.log(accordion_parent)
        if(selected_accordion.classList.contains('active')) {
          setTimeout(() => {
            selected_accordion.classList.remove('active');
          }, 100);
        } else if (accordion_parent) {
          console.log('Accordion parent', accordion_parent);
          const sibling_accordions = accordion_parent.querySelectorAll('.accordion-wrapper');
          // Close sibling accordions 
          if (sibling_accordions) {
            sibling_accordions.forEach( accordion => {
                accordion.classList.remove('active');
            });
      
            setTimeout(() => {
              selected_accordion.classList.add('active');
            }, 100);
            
          }
        }
      }
});